import { createActionConst } from '../../../utils/action.utils';

const CALENDAR_ITEM_NAMESPACE = 'CALENDAR_ITEM';

export const STORE_CALENDAR_ITEM = createActionConst(CALENDAR_ITEM_NAMESPACE, 'STORE_CALENDAR_ITEM');
export const CLEAR_CALENDAR_ITEM = createActionConst(CALENDAR_ITEM_NAMESPACE, 'CLEAR_CALENDAR_ITEM');
